// extracted by mini-css-extract-plugin
module.exports = {"root":"GridLayout_root__3akDy","adaptive":"GridLayout_adaptive__1l4s3"};